import { gql } from '@apollo/client';
export default gql`
  query getWorkTickets(
    $start: Date
    $end: Date
    $contractId: String
    $departmentId: String
    $employeeId: String
  ) {
    getWorkTickets(
      start: $start
      end: $end
      contractId: $contractId
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        time
        title
        desc

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        contractId
        contractName
        contractNameAr

        bonos
        overtime
        deduction
        isWorking
        isAbsent
        isShift1
        isShift2

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
